export default "__VITE_ASSET__DFhOyiWD__"